import Vue from 'vue'
import { Select, Option, Dialog, Input, Message } from 'element-ui'

Vue.use(Select)
Vue.use(Option)
Vue.use(Dialog)
Vue.use(Input)
Vue.component(Message)

Vue.prototype.$message = Message
